var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('calendesk-information-message',{attrs:{"color":"error","additional-class":("white--text " + _vm.additionalClass),"icon-color":"white","icon":_vm.icon,"dense":_vm.dense}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }